var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.562 11.438A1.45 1.45 0 0 0 19.5 11H19V8q0-2.875-2.062-4.937T12 1 7.062 3.063 5 8v3h-.5q-.625 0-1.062.438A1.45 1.45 0 0 0 3 12.5v9q0 .625.438 1.063Q3.874 23 4.5 23h15q.625 0 1.063-.437.436-.438.437-1.063v-9q0-.624-.438-1.062M16 11H8V8q0-1.656 1.172-2.828A3.85 3.85 0 0 1 12 4q1.656 0 2.828 1.172A3.85 3.85 0 0 1 16 8z"
})));
export default SvgLocked;